import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { GridSvg } from './Grid';

export const GridIcon = createIcon('grid', GridSvg);
/**
 * @deprecated используйте GridIcon
 */
export const withGridIcon = withIcon('grid', GridSvg);
